import { useAppSelector } from 'hooks/hooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, CardBody, CardGroup, CardText } from "reactstrap";
import styled from "styled-components";
import { hexToRgbA } from "services/common.service";

const CustomerDiv = styled.div`
    background: radial-gradient(circle at 25% 20%, var(--banner-primary) 0%, var(--banner-secondary) 100%);
    min-height: 200px;
    position: relative;
    color: var(--banner-fg);
`;

const ContactAnchor = styled.a`
    color: var(--banner-fg);
    text-decoration: underline !important;
    &:hover {
        color: var(--banner-hover) !important;
    }
`;

const Banner = () => {

    const customer = useAppSelector(x => x.customers.selectedCustomer);

    if (!customer) return null;

    const cssVars = {
        "--banner-primary": customer.primaryColor || "",
        "--banner-secondary": customer.secondaryColor || "",
        "--banner-fg": customer.primaryForeground || "",
        "--banner-hover": hexToRgbA(customer.primaryColor || "", .9),
    } as React.CSSProperties;


    const formatPhoneNumber = (phoneNumberString: string) => {
        var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
        var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            return '(' + match[1] + ') ' + match[2] + '-' + match[3];
        }
        return null;
    }

    return (
        <CustomerDiv style={cssVars}>
            <div className="row">
                <Card className="bg-transparent border-0 col">
                    {customer.logoHex ?
                        <img className="rounded mx-auto my-3 my-xl-auto d-block bg-opacity-10 img-fluid" src={'data:image/' + customer.logoExtension + ';base64,' + customer.logoHex} alt={customer.logoFileName || customer.name || "Company Logo"} />
                        :
                        <span className="fs-3 m-auto fw-bold">
                            [Company Logo]
                        </span>
                    }

                </Card>
                <CardGroup className="d-none d-xl-flex col-xl-9 col">
                    <Card className="bg-transparent">
                        <CardBody>
                            <CardText className="mx-2">
                                <label className="fw-bold">Company Name</label><br />
                                <span className="fs-5 fw-bolder"> {customer.name}</span>
                                <br />
                                <label className="fw-bold">Phone</label>
                                <FontAwesomeIcon icon='phone' className="ms-1 me-2" />
                                {customer.phone ?
                                    <>
                                        {customer.phone}
                                    </>
                                    :
                                    <span>Not Provided</span>
                                }
                                <br />
                                <label className="fw-bold">Email</label>
                                <FontAwesomeIcon icon='at' className="ms-1 me-2" />
                                {customer.email ?
                                    <>
                                        {customer.email}
                                    </>
                                    :
                                    <span>Not Provided</span>
                                }
                                <br />
                            </CardText>
                        </CardBody>
                    </Card>
                    <Card className="bg-transparent">
                        <CardBody>
                            <CardText className="mx-2">
                                <label className="fw-bold">Address</label>
                                <FontAwesomeIcon icon='envelope' className="me-2 ms-1" />
                                <br />
                                <span dangerouslySetInnerHTML={{ __html: customer.formattedAddress ?? "" }} />
                            </CardText>
                        </CardBody>
                    </Card>
                    <Card className="bg-transparent">
                        <CardBody>
                            <CardText className="mx-2 d-flex flex-column">
                                <label className="fw-bold">Sales Rep</label>
                                {customer.salesUser ?
                                    <>
                                        <span>{customer.salesUser.firstName + " " + customer.salesUser.lastName}</span>
                                        <label className="fw-bold">Phone
                                            <FontAwesomeIcon icon='phone' className="ms-1" />
                                        </label>

                                        {customer.salesUser.phoneNumber ?
                                            <ContactAnchor href={"tel:+1" + customer.salesUser.phoneNumber}>
                                                {formatPhoneNumber(customer.salesUser.phoneNumber)}
                                            </ContactAnchor> :
                                            <span>Not specified</span>}
                                        <label className="fw-bold">Email
                                            <FontAwesomeIcon icon='at' className="ms-1" />
                                        </label>
                                        <ContactAnchor href={"mailto:" + customer.salesUser.email}>
                                            {customer.salesUser.email}
                                        </ContactAnchor>
                                    </>
                                    :
                                    <span>{customer.salesRepresentative || "Not Specified"}</span>
                                }

                            </CardText>
                        </CardBody>
                    </Card>
                    <Card className="bg-transparent">
                        <CardBody>
                            <CardText className="mx-2 d-flex flex-column">
                                <label className="fw-bold">Contact BCD</label>
                                <label>
                                    <ContactAnchor href="https://www.bcdvideo.com/support-ticket-request/" target="_blank" className="me-2">
                                        Support
                                    </ContactAnchor>
                                    |
                                    <ContactAnchor href="https://www.bcdvideo.com/contact-us/" target="_blank" className="mx-2">
                                        On the web
                                    </ContactAnchor>
                                    |
                                    <ContactAnchor href="https://portal.bcdvideo.com/customer/submit-po" target="_blank" className="mx-2">
                                        Submit PO
                                    </ContactAnchor>
                                    <FontAwesomeIcon icon="external-link" />
                                </label>                  
                                <label className="fw-bold">Phone
                                    <FontAwesomeIcon icon='phone' className="ms-1" />
                                </label>
                                <ContactAnchor href="tel:+18472051922">
                                    (847) 205-1922
                                </ContactAnchor>
                                <label className="fw-bold">Email
                                    <FontAwesomeIcon icon='at' className="ms-1" />
                                </label>
                                <ContactAnchor href="mail:info@bcdvideo.com">
                                    info@bcdvideo.com
                                </ContactAnchor>                              
                            </CardText>
                        </CardBody>
                    </Card>
                </CardGroup>
            </div>
        </CustomerDiv>
    );
}

export default Banner;